import { useMemo } from 'react';
import styled from 'styled-components';
import type { ImageValue } from '@elfsight/configurator-contracts';
import { useSettings } from '@wu/widget-core';
import { getFileData } from '../../../../helpers';

interface ImageProps {
  image: ImageValue;
  alt: string;
}

export function Image({ image, alt }: ImageProps) {
  const { sectionsLayout, colorScheme, showDefaultImage } = useSettings();
  const url = useMemo(() => getFileData(image).url, [image]);

  return (
    <ImageComponentContainer>
      {(image && <ImageComponent key={url} src={url} alt={alt} />) ||
        (((!image && sectionsLayout !== 'masonry') || showDefaultImage) && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 320 320"
            style={{
              backgroundColor: colorScheme === 'dark' ? '#000' : '#fff'
            }}
          >
            <g transform="translate(68 68)">
              <circle
                cx="92"
                cy="92"
                r="92"
                fill={colorScheme === 'dark' ? '#3C3C3C' : '#e1e1e1'}
              />
              <circle
                cx="92"
                cy="92"
                r="61"
                fill={colorScheme === 'dark' ? '#323232' : '#d7d7d7'}
              />
            </g>

            <path
              fill={colorScheme === 'dark' ? '#3C3C3C' : '#e1e1e1'}
              d="M289.8 78c7.88 0 14.268 10.074 14.268 22.5 0 9.794-3.968 18.126-9.508 21.217l-.76 10.061 2.796 96.225a6.8 6.8 0 0 1-6.599 6.994l-.197.003a6.8 6.8 0 0 1-6.8-6.8l.003-.197 2.797-96.225-.76-10.06c-5.54-3.091-9.509-11.424-9.509-21.218 0-12.426 6.388-22.5 14.269-22.5zM46.787 81.292a.5.5 0 0 1 .462.461l1.852 25.072a.4.4 0 0 0 .798 0l1.826-24.712a.5.5 0 0 1 .997.004L55 116.41c0 4.43-2.719 8.225-6.58 9.807l-.42 5.56 2.797 96.225a6.8 6.8 0 1 1-13.594 0L40 131.778l-.42-5.56a10.597 10.597 0 0 1-6.58-9.807l2.278-34.294a.5.5 0 0 1 .997-.004l1.826 24.712a.4.4 0 0 0 .798 0l1.852-25.072a.5.5 0 0 1 .998 0l1.852 25.072a.4.4 0 0 0 .798 0l1.852-25.072a.5.5 0 0 1 .536-.461zM268.8 65l-1 66h-.06l.06.778 2.796 96.225a6.8 6.8 0 1 1-13.593 0l2.797-96.225V131c-.67-10.58-1.227-20.746-1.67-30.5-.31-6.814-.62-14.643-.93-23.488-.224-6.406 4.787-11.78 11.193-12.005l.203-.005.204-.002z"
            />
          </svg>
        ))}
    </ImageComponentContainer>
  );
}

export const ImageComponent = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
  opacity: 1;
  transition: 0.1s ease all;
`;
export const ImageComponentContainer = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 4px;
  margin-right: 16px;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;

  &:after {
    content: '';
    border: solid 0.8px rgba(126, 126, 126, 0.1);
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
  }
`;
